<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">{{"connectivity" | translate}}</h5>
            <h6 class="card-subtitle text-muted">{{"connectivityDescription" | translate}}</h6>
        </div>
        <div class="card-body">
            <form>
                <div class="form-group row">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"connectivity_ssid_text" | translate}}</label>
                    <div class="col-sm-8 position-relative">
                        <input type="text" class="form-control" autocomplete="off"
                            [placeholder]="'connectivity_ssid_text' | translate" name="ssid"
                            [ngModel]="ssid" (ngModelChange)="onSsidChange($event)"
                            (focus)="openDropdown()" (blur)="closeDropdownDelayed()">
                        <div class="list-group position-absolute w-100 shadow-sm"
                            style="z-index: 1000; max-height: 220px; overflow-y: auto;"
                            *ngIf="showDropdown && filteredNetworks.length">
                            <button type="button" class="list-group-item list-group-item-action py-1 px-2"
                                *ngFor="let net of filteredNetworks" (mousedown)="selectNetwork(net)">
                                {{net.ssid}} <small class="text-muted">({{net.rssi}} dBm)</small>
                            </button>
                        </div>
                        <div class="d-flex align-items-center gap-2 mt-1">
                            <small class="form-text text-muted mb-0" *ngIf="scanning">{{"scanning_wifi_networks" | translate}}</small>
                            <small class="form-text text-muted mb-0" *ngIf="!scanning && scanned && networks.length === 0">
                                {{"ble_manual_ssid" | translate}}
                            </small>
                            <small class="form-text text-muted mb-0" *ngIf="!scanning && scanned && networks.length > 0">
                                {{ networks.length }} {{"scan_wifi_networks" | translate}}
                            </small>
                            <button type="button" class="btn btn-sm btn-link p-0" (click)="scanNetworks()" [disabled]="scanning">
                                <i class="fas fa-sync-alt"></i> {{(scanned ? "scan_again" : "scan_wifi_networks") | translate}}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group row" *ngIf="ssidChanged">
                    <div class="col-sm-8 offset-sm-4">
                        <small class="form-text text-muted">{{"wifi_new_network_password_required" | translate}}</small>
                    </div>
                </div>

                <div class="form-group row" *ngIf="!ssidChanged">
                    <div class="col-sm-8 offset-sm-4">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" [id]="'wantsChangePassword_' + device"
                                [checked]="wantsChangePassword" (change)="toggleChangePassword()">
                            <label class="form-check-label" [for]="'wantsChangePassword_' + device">{{"wifi_change_password" | translate}}</label>
                        </div>
                        <small class="form-text text-muted" *ngIf="!wantsChangePassword">{{"wifi_password_not_readable" | translate}}</small>
                    </div>
                </div>

                <div class="form-group row" *ngIf="passwordRequired">
                    <label class="col-form-label col-sm-4 text-sm-right">{{"connectivity_pass" | translate}}</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input [type]="showPassword ? 'text' : 'password'" class="form-control"
                                [placeholder]="'connectivity_pass' | translate" name="password"
                                [(ngModel)]="password" autocomplete="new-password">
                            <button type="button" class="btn btn-outline-secondary" (click)="showPassword = !showPassword">
                                <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-10 ms-sm-auto">
                        <button type="submit" class="btn btn-primary" (click)="save()"
                            [disabled]="saveDisabled">{{"overwrite" | translate}}</button>
                        <button type="button" class="btn btn-light ms-2" (click)="restore()"
                            [disabled]="!ssidChanged && !wantsChangePassword">{{"restore" | translate}}</button>
                    </div>
                </div>
            </form>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
                <div class="alert-message">
                    {{ error }}
                </div>
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
                <div class="alert-message">
                    {{"updatedSuccesfully" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
